import React from "react";
import SearchForm from "components/SearchForm";

function Home() {
  return (
    <main>
      <h1 className="center">GitHub Issue Finder</h1>
      <SearchForm />
    </main>
  );
}

export default Home;
